import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import LogoMarquee from "@/components/LogoMarquee";
import ClientTile from "@/components/ClientTile";
import SectionHeading from "@/components/SectionHeading";
import { Factory } from "lucide-react";
import { CLIENTS, INDUSTRIES } from "@/data/clients";

export default function Clients() {
  return (
    <div>
      <PageHero
        eyebrow="Clients"
        title="Trusted by industry — across India."
        description="Manufacturers, foundries, engineering enterprises and institutions rely on Nago International for their day-to-day and mission-critical industrial supply."
        image="https://images.unsplash.com/photo-1716643863806-989dd76ae093?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />

      <section className="section bg-slate-50">
        <div className="container-nago">
          <SectionHeading
            eyebrow="Valued clients"
            title="A partial list of the organisations we serve."
            align="center"
          />
        </div>
        <div className="mt-12">
          <LogoMarquee
            items={CLIENTS}
            testId="clients-marquee-1"
            renderItem={(c) => <ClientTile short={c.short} name={c.name} image={c.image} />}
          />
        </div>
        <div className="mt-8">
          <LogoMarquee
            items={[...CLIENTS].reverse()}
            speed="slow"
            testId="clients-marquee-2"
            renderItem={(c) => <ClientTile short={c.short} name={c.name} image={c.image} />}
          />
        </div>
      </section>

      <section className="section bg-white">
        <div className="container-nago">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {CLIENTS.map((c) => (
              <div
                key={c.name}
                className="bg-white border border-slate-200 rounded-xl p-5 flex items-center gap-3 hover:border-[#1E3A8A] transition-colors"
                data-testid={`client-card-${c.short.toLowerCase().replace(/\s/g, "-")}`}
              >
                <div className="w-14 h-14 shrink-0 bg-white border border-slate-200 rounded-xl flex items-center justify-center p-1.5">
                  {c.image ? (
                    <img src={c.image} alt={c.name} className="max-w-full max-h-full object-contain" loading="lazy" />
                  ) : (
                    <Factory className="w-5 h-5 text-[#1E3A8A]" />
                  )}
                </div>
                <div className="min-w-0">
                  <div className="font-display font-bold text-sm text-slate-900 uppercase tracking-wide">
                    {c.short}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5 truncate">{c.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-industrial-soft">
        <div className="container-nago">
          <SectionHeading
            eyebrow="Industries served"
            title="Wherever precision and reliability matter."
          />
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {INDUSTRIES.map((i) => (
              <div
                key={i}
                className="bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-700 font-medium hover:border-[#E30613] transition-colors"
              >
                {i}
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
